import { createFileRoute } from "@tanstack/react-router";

import { seo } from "@/lib/seo";
import { assertDraftRouteVisible } from "@/lib/draft-routes";
import { PagePlaceholder } from "@/components/site/PagePlaceholder";

export const Route = createFileRoute("/_site/services/sba-loan-consulting")({
  // Draft route: 404s on the live domain, renders normally elsewhere. See src/lib/draft-routes.ts.
  beforeLoad: assertDraftRouteVisible,
  head: () =>
    seo({
      title: "SBA Loan Consulting",
      description:
        "Preparation and packaging support for SBA loan applications: projections, narratives, and lender-ready documents.",
      path: "/services/sba-loan-consulting",
      noindex: true,
    }),
  component: Page,
});

function Page() {
  return <PagePlaceholder title={"SBA loan consulting"} intro={"[SUPPLY: service detail copy]"} />;
}
